import _typeof from "@babel/runtime/helpers/typeof";
/**
 * Assigns the node to all the refs passed in the argument.
 */
export default function mergeRefs(refs) {
  return function (value) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref !== null && _typeof(ref) === 'object') {
        ref.current = value;
      }
    });
  };
}